import {ModuleEnum} from 'src/api/ProactApiClient';
import {FormCustomOperations} from './customOperations';
import {useModulePermissions} from './useModulePermissions';

/**
 * Hook for Forms module permissions.
 * Includes standard operations plus Forms-specific custom operations.
 */
export function useFormPermissions() {
  return useModulePermissions(ModuleEnum.Forms, FormCustomOperations);
}
